import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {DataService} from '../data.service';
import {FrtBookShipmentAccessorialMsgs} from 'src/app/features/frt-shipment-accessorial-additionalinfo/frt-shipment-accessorial-additional';


@Injectable({
  providedIn: 'root'
})
export class FrtShipmentAccessorialAdditionalInfoService extends DataService {

  private baseURI = this.apiUri + '/frtaccessorialMsgs/';

  constructor(http: HttpClient) {
    super(http);
  }

  getMessagesByAccessorialsId(shipmentAccrlsId: any): Observable<any> {
    this.setUri(this.baseURI + shipmentAccrlsId + '/shipmentAccrlsId');
    return this.get();
  }

  deleteAccessorialMessages(shipmentAccrlsId: any): Observable<any> {
    this.setUri(this.baseURI + shipmentAccrlsId + '/deleteMessages');
    return this.update(shipmentAccrlsId);
  }

  saveOrUpdateAccessorialMessages(FrtBookShipmentAccessorialMsg: FrtBookShipmentAccessorialMsgs[]): Observable<any> {
    this.setUri(this.baseURI + 'update/');
    return this.update(FrtBookShipmentAccessorialMsg);
  }
}
